// @ts-nocheck
import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";

export const initMiniGameService = async ({
  provider,
  id,
  currency,
  isMobile,
}: {
  provider: string;
  id: string | number;
  currency: string;
  isMobile: boolean;
}) => {
  const url = `${ConfEnv.API_URL.GAMES_INIT}/${encodeURIComponent(provider)}/${encodeURIComponent(id)}?currency=${encodeURIComponent(currency)}&is_mobile=${isMobile}`;
  return privateRequest.get(url);
};
